'use strict';

var React = require('react');

var SvgLogoTwitchIcon = function SvgLogoTwitchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.75h-1v3h1v-3Zm-3.75 0h1v3h-1v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m6.5 3-2.5 2.5v9h3v2.5l2.5-2.5h2l4.5-4.5v-7h-9.5Zm8.5 6.5-2 2h-2l-1.75 1.75v-1.75h-2.25v-7.5h8v5.5Z"
  }));
};
SvgLogoTwitchIcon.displayName = "LogoTwitchIcon";

exports.SvgLogoTwitchIcon = SvgLogoTwitchIcon;
